export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: string;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: string;
  /** The built-in `Decimal` scalar type. */
  Decimal: number;
  UUID: string;
};

/** Addressinformationen */
export type Adresse = {
  __typename: 'Adresse';
  /** Ort */
  ort: Maybe<Scalars['String']>;
  /** Postleitzahl */
  postleitzahl: Maybe<Scalars['String']>;
  /** Strasse und Hausnummer */
  strasse: Maybe<Scalars['String']>;
};

/** Informationen zu einem Artikel */
export type Artikel = {
  __typename: 'Artikel';
  /** Name des Materials */
  name: Scalars['String'];
};

/** Informationen zu einer Vertriebsaufgabe */
export type Aufgabe = {
  __typename: 'Aufgabe';
  /** Datum der Erstellung des Aufgaben */
  anlagedatum: Scalars['DateTime'];
  /** Artikel des in der Aufgabe empfohlenen Produktes */
  artikel: Maybe<Scalars['String']>;
  /** Bearbeiter */
  bearbeiter: Maybe<Mitarbeiter>;
  /** Beschreibung des Aufgaben */
  beschreibung: Scalars['String'];
  /** Detaillierte Informationen zum Aufgabe */
  details: Maybe<Scalars['String']>;
  /** Alle erfolglosen Antwortmöglichkeiten */
  erfolgloseAntworten: Array<Scalars['String']>;
  /** Alle erfolgreichen Antwortmöglichkeiten */
  erfolgreicheAntworten: Array<Scalars['String']>;
  /** Ergebnis der Bearbeitung */
  ergebnis: Maybe<Scalars['String']>;
  /** Gibt eine zum gewählten Ergebnis passende Option an. */
  ergebnisOption: Maybe<Scalars['String']>;
  /** Ersteller */
  ersteller: Mitarbeiter;
  /** Fachliche Id des Aufgaben */
  fachlicheId: Scalars['String'];
  /** Optionaler Termin für die Bearbeitung des Aufgaben */
  faelligkeit: Maybe<Scalars['DateTime']>;
  /** Identität der Aufgabe */
  id: Scalars['UUID'];
  /** Markierung einer Aufgabe als archiviert */
  istArchiviert: Scalars['Boolean'];
  /** Kennzeichen, ob der Bearbeiter manuell zugewiesen wurde */
  istBearbeiterManuellZugewiesen: Scalars['Boolean'];
  istBerechtigtAbzuschliessen: Scalars['Boolean'];
  /** Falls vorhanden, die Kampagne im Rahmen derer die Aufgabe erstellt wurde */
  kampagne: Maybe<Scalars['String']>;
  /** Kategorie des Aufgaben */
  kategorie: Scalars['String'];
  /** Kommentar zur Erläuterung des Ergebnisses */
  kommentar: Maybe<Scalars['String']>;
  /** Marke des in der Aufgabe empfohlenen Produktes */
  marke: Maybe<Scalars['String']>;
  /** Zielobjekt des Aufgaben */
  objekt: Objekt;
  /** Empfohlenes Produkt */
  produkt: Maybe<Scalars['String']>;
  /** Verarbeitungshistorie */
  protokoll: Array<Protokolleintrag>;
  /** Aktueller Verarbeitungszustand des Aufgaben */
  status: Scalars['String'];
  /** Identifikator für einen Teilnehmer an der Umfrage */
  teilnehmerId: Maybe<Scalars['String']>;
  /** Titel des Aufgaben */
  titel: Scalars['String'];
  /** Typ des Aufgaben */
  typ: Scalars['String'];
  /** Identifikator für eine Umfrage */
  umfrageId: Maybe<Scalars['String']>;
  /** Alle ungewissen Antwortmöglichkeiten */
  ungewisseAntworten: Array<Scalars['String']>;
  /** Warengruppe des in der Aufgabe empfohlenen Produktes */
  warengruppe: Maybe<Scalars['String']>;
};

/** Mögliche Filteroptionen für die Abfrage von Aufgaben */
export type AufgabenFilterInput = {
  /** Filtern nach Aufgabentypen */
  aufgabentyp?: InputMaybe<Array<Scalars['String']>>;
  /** Filtern nach Bearbeiter */
  bearbeiter?: InputMaybe<Array<Scalars['UUID']>>;
  /** Filtern nach Betriebstyp */
  betriebstyp?: InputMaybe<Array<Scalars['String']>>;
  /** Filtern nach Channel */
  channel?: InputMaybe<Array<Scalars['String']>>;
  /** Filtern nach Produkt */
  produkt?: InputMaybe<Array<Scalars['String']>>;
  /** Filtern nach Status bzw. Ergebnis */
  statusErgebnis?: InputMaybe<Array<Scalars['String']>>;
  /** Filtern nach Suchbegriff in den Feldern Fachlicher Schlüssel, Titel, Objekt (Nummer, Name), Bearbeitername */
  suchbegriff?: InputMaybe<Scalars['String']>;
  /** Filtern nach Warengruppe */
  warengruppe?: InputMaybe<Array<Scalars['String']>>;
};

export type AufgabenInput = {
  beschreibung: Scalars['String'];
  faelligkeit?: InputMaybe<Scalars['Date']>;
  titel: Scalars['String'];
};

/** Anzahl der Aufgaben mit einem bestimmten Status */
export type AufgabenPerStatus = {
  __typename: 'AufgabenPerStatus';
  /** Anzahl der Aufgaben in diesem Status */
  anzahl: Scalars['Int'];
  /** Status der Aufgaben */
  status: Scalars['String'];
};

/** Anzahl der Aufgaben für ein Objekt */
export type AufgabenProObjekt = {
  __typename: 'AufgabenProObjekt';
  /** Anzahl der Aufgaben für dieses Objekt */
  anzahl: Scalars['Int'];
  /** Id des Objektes */
  objektId: Scalars['UUID'];
};

/** Mögliche Felder nach denen sortiert werden kann */
export enum AufgabenSortierung {
  /** Der Bearbeiter der Aufgabe */
  Bearbeiter = 'BEARBEITER',
  /** Erstelldatum */
  Erstelldatum = 'ERSTELLDATUM',
  /** Ersteller */
  Ersteller = 'ERSTELLER',
  /** Fälligkeit */
  Faelligkeit = 'FAELLIGKEIT',
  /** Id der Aufgabe */
  Id = 'ID',
  /** Objektname */
  Objektname = 'OBJEKTNAME',
  /** Objektnummer */
  Objektnummer = 'OBJEKTNUMMER',
  /** Standardsortierung */
  Standard = 'STANDARD',
  /** Der Status der Aufgabe */
  Status = 'STATUS',
  /** Titel der Vertriebsaufgabe */
  Titel = 'TITEL',
  /** Aufgaben Typ */
  Typ = 'TYP'
}

export type Bearbeiter = {
  __typename: 'Bearbeiter';
  email: Scalars['String'];
  id: Scalars['UUID'];
  isDeleted: Scalars['Boolean'];
  isSelectable: Scalars['Boolean'];
  nachname: Scalars['String'];
  vorname: Scalars['String'];
};

/** Eigenschaft einer Entität mit ihren möglichen Werten */
export type Eigenschaft = {
  __typename: 'Eigenschaft';
  /** Alphabetische Sortierung in einer Liste */
  istAlphabetischSortiert: Scalars['Boolean'];
  /** Sichtbarkeit in der Nutzerschnittstelle */
  istSichtbar: Scalars['Boolean'];
  /** Fachlicher Schlüssel für die Eigenschaft */
  name: Scalars['String'];
  /** Mögliche Werte der Eigenschaft */
  werte: Array<Eigenschaftswert>;
};

/** Werte für Aufzählungstypen */
export type Eigenschaftswert = {
  __typename: 'Eigenschaftswert';
  /** Name für die Anzeige in der Nutzerschnittstelle */
  anzeigeName: Scalars['String'];
  /** Beschreibung des Wertes */
  beschreibung: Maybe<Scalars['String']>;
  /** Fachlicher Schlüssel für den Wert */
  bezeichnung: Scalars['String'];
  /** Gibt an, ob der Wert genutzt werden darf. */
  istAktiv: Scalars['Boolean'];
  /** Position des Wertes beim Sortieren */
  position: Maybe<Scalars['Int']>;
};

export type ErgebnisOfAufgabe = {
  __typename: 'ErgebnisOfAufgabe';
  aktuelleSeite: Array<Aufgabe>;
  beschreibung: SeitenBeschreibung;
};

export type ErgebnisOfKampagne = {
  __typename: 'ErgebnisOfKampagne';
  aktuelleSeite: Array<Kampagne>;
  beschreibung: SeitenBeschreibung;
};

export type ErgebnisOfObjekt = {
  __typename: 'ErgebnisOfObjekt';
  aktuelleSeite: Array<Objekt>;
  beschreibung: SeitenBeschreibung;
};

/** Informationen zu einer Vertriebsaufgabe */
export type Kampagne = {
  __typename: 'Kampagne';
  /** Datum der Erstellung des Aufgaben */
  anlagedatum: Scalars['DateTime'];
  /** Identität der Aufgabe */
  aufgabenId: Scalars['UUID'];
  /** Titel des Aufgaben */
  aufgabenTitel: Scalars['String'];
  /** Typ des Aufgaben */
  aufgabenTyp: Scalars['String'];
  /** Beschreibung des Aufgaben */
  beschreibung: Scalars['String'];
  /** Ersteller */
  ersteller: Mitarbeiter;
  /** Optionaler Termin für die Bearbeitung des Aufgaben */
  faelligkeit: Maybe<Scalars['DateTime']>;
  /** Titel der Kampagne */
  name: Scalars['String'];
};

/** Mögliche Felder nach denen sortiert werden kann */
export enum KampagnenSortierung {
  /** Datum der Erstellung des Aufgaben */
  Anlagedatum = 'ANLAGEDATUM',
  /** Titel der Aufgabe */
  AufgabenTitel = 'AUFGABEN_TITEL',
  /** Ersteller */
  Ersteller = 'ERSTELLER',
  /** Fälligkeit */
  Faelligkeit = 'FAELLIGKEIT',
  /** Name der Kampagne */
  Name = 'NAME',
  /** Standardsortierung (Name, Anlagedatum absteigend) */
  Standard = 'STANDARD'
}

export type KeyValuePairOfStringAndString = {
  __typename: 'KeyValuePairOfStringAndString';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Informationen zu einer Marke */
export type Marke = {
  __typename: 'Marke';
  /** Name der Marke */
  name: Scalars['String'];
};

/** Informationen zu einem Mitarbeiter */
export type Mitarbeiter = {
  __typename: 'Mitarbeiter';
  /** Identität des Mitarbeiters */
  id: Scalars['UUID'];
  /** Mailadresse des Mitarbeiters */
  mailadresse: Maybe<Scalars['String']>;
  /** Nachname */
  nachname: Scalars['String'];
  /** Name des Mitarbeiters */
  name: Scalars['String'];
  /** Die Rollen des Mitarbeiters für die VertriebsApp */
  rollen: Array<Scalars['String']>;
  /** Vorname */
  vorname: Scalars['String'];
};

/** Mutations für Aufgaben */
export type Mutation = {
  __typename: 'Mutation';
  /** Bearbeitung mit der Dokumentation der Ergebnisse abschließen */
  aufgabeAbschliessen: Aufgabe;
  /**
   * Vertriebsaufgabe archivieren
   *
   *
   * **Returns:**
   * Aufgabe
   */
  aufgabeArchivieren: Aufgabe;
  aufgabeAusKarteErstellen: Array<ResultOfString>;
  /**
   * Erstellt eine neue Aufgabe
   *
   *
   * **Returns:**
   * Die erstellte Aufgabe
   */
  aufgabeErstellen: Aufgabe;
  /**
   * Vertriebsaufgabe für die Bearbeitung freigeben
   *
   *
   * **Returns:**
   * Aufgabe
   */
  aufgabeFreigeben: Aufgabe;
  /**
   * Erstellt eine neue Aufgabe auf Basis einer existierenden Aktionsaufgabe.
   * Als Bearbeiter wird der aktuelle Aussendienstmitarbeiter zugewiesen.
   *
   *
   * **Returns:**
   * Die erstellte Aufgabe
   */
  aufgabeFuerKampagneErstellen: Aufgabe;
  /**
   * Eine versehentlich erstellte Aufgabe löschen
   *
   *
   * **Returns:**
   * Aufgabe
   */
  aufgabeLoeschen: VerarbeitungsErgebnis;
  /**
   * Zwischenergebnis zu einer Aufgabe erfassen
   *
   *
   * **Returns:**
   * Aufgabe
   */
  aufgabeZwischenergebnisErfassen: Aufgabe;
  /**
   * Archivierung der Vertriebsaufgabe zurücknehmen
   *
   *
   * **Returns:**
   * Aufgabe
   */
  aufgabenArchivierungZuruecknehmen: Aufgabe;
  /**
   * Freigabe der Vertriebsaufgabe für die Bearbeitung zurücknehmen
   *
   *
   * **Returns:**
   * Aufgabe
   */
  aufgabenFreigabeZuruecknehmen: Aufgabe;
  /** Einer Vertriebsaufgabe einen Bearbeiter zuwweisen. */
  bearbeiterZuweisen: Aufgabe;
  /**
   * Ein temporäres Objekt für einen Neukunden erstellen.
   *
   *
   * **Returns:**
   * Das erstellte Objekt
   */
  neukundenObjektErstellen: Objekt;
};


/** Mutations für Aufgaben */
export type MutationAufgabeAbschliessenArgs = {
  ergebnis: Scalars['String'];
  ergebnisOption: Scalars['String'];
  id: Scalars['UUID'];
  kommentar?: InputMaybe<Scalars['String']>;
};


/** Mutations für Aufgaben */
export type MutationAufgabeArchivierenArgs = {
  id: Scalars['UUID'];
};


/** Mutations für Aufgaben */
export type MutationAufgabeAusKarteErstellenArgs = {
  aufgabe: AufgabenInput;
  bearbeiter: Scalars['UUID'];
  objekte: Array<ObjektInput>;
};


/** Mutations für Aufgaben */
export type MutationAufgabeErstellenArgs = {
  artikel?: InputMaybe<Scalars['String']>;
  bearbeiter?: InputMaybe<Scalars['UUID']>;
  beschreibung: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  fachlicheId?: Scalars['String'];
  faelligkeit?: InputMaybe<Scalars['DateTime']>;
  kategorie: Scalars['String'];
  marke?: InputMaybe<Scalars['String']>;
  objektId: Scalars['UUID'];
  produkt?: InputMaybe<Scalars['String']>;
  titel: Scalars['String'];
  typ: Scalars['String'];
  warengruppe?: InputMaybe<Scalars['String']>;
};


/** Mutations für Aufgaben */
export type MutationAufgabeFreigebenArgs = {
  id: Scalars['UUID'];
};


/** Mutations für Aufgaben */
export type MutationAufgabeFuerKampagneErstellenArgs = {
  aufgabenId: Scalars['UUID'];
  objektId: Scalars['UUID'];
};


/** Mutations für Aufgaben */
export type MutationAufgabeLoeschenArgs = {
  id: Scalars['UUID'];
};


/** Mutations für Aufgaben */
export type MutationAufgabeZwischenergebnisErfassenArgs = {
  id: Scalars['UUID'];
  kommentar?: InputMaybe<Scalars['String']>;
  zwischenergebnisOption: Scalars['String'];
};


/** Mutations für Aufgaben */
export type MutationAufgabenArchivierungZuruecknehmenArgs = {
  id: Scalars['UUID'];
};


/** Mutations für Aufgaben */
export type MutationAufgabenFreigabeZuruecknehmenArgs = {
  id: Scalars['UUID'];
};


/** Mutations für Aufgaben */
export type MutationBearbeiterZuweisenArgs = {
  aufgabenId: Scalars['UUID'];
  mitarbeiterId: Scalars['UUID'];
};


/** Mutations für Aufgaben */
export type MutationNeukundenObjektErstellenArgs = {
  gedatId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  ort: Scalars['String'];
  postleitzahl?: InputMaybe<Scalars['String']>;
  strasse: Scalars['String'];
};

/** Kunde eines GFGH, beispielsweise ein Restaurant, Hotel, Festival, ein Getränkeeinzelhändler oder auch eine Tankstelle */
export type Objekt = {
  __typename: 'Objekt';
  additionalInformation: Array<KeyValuePairOfStringAndString>;
  /** Team Beverage interne ID für den Kunden */
  adressId: Scalars['Int'];
  /** Adresse des Objektes */
  adresse: Maybe<Adresse>;
  /** Aktuelle Aufgaben für das Objekt */
  aufgaben: Array<Aufgabe>;
  /** Statistik über die Status der aktuellen Aufgaben */
  aufgabenStatistik: Array<AufgabenPerStatus>;
  /**
   * Betriebstyp des Kunden
   * (Genauere Einteilung des Kunden / bei alle Kunden im Channel 10/70/80 notwendig)
   */
  betriebstyp: Maybe<Scalars['String']>;
  /**
   * Breitengrad der Position
   * TODO: Geokoordinaten des Objektes
   */
  breitengrad: Maybe<Scalars['Decimal']>;
  /**
   * Channel des Kunden
   * (Verkaufskanal in dem der Kunde eingeteilt ist)
   */
  channel: Maybe<Scalars['String']>;
  /**
   * GEDAT ID zu dem Objekt
   * (Branchenweite Nummer zur Identifikation des Objektes zwischen unabhängigen Parteien)
   */
  gedatId: Maybe<Scalars['String']>;
  /** Das Objekt verfügt über einen Biergarten */
  hatBiergarten: Maybe<Scalars['Boolean']>;
  /** Das Objekt verfügt über einen Saal */
  hatSaal: Maybe<Scalars['Boolean']>;
  /** Das Objekt verfügt über eine Terrasse */
  hatTerrasse: Maybe<Scalars['Boolean']>;
  /** Identität des Objektes */
  id: Scalars['UUID'];
  /**
   * Längengrad der Position
   * TODO: Geokoordinaten des Objektes
   */
  laengengrad: Maybe<Scalars['Decimal']>;
  /** Identität des Mandanten der Organisation des Partners */
  mandantenId: Scalars['UUID'];
  /** Bezeichnung des Objektes/Kunden im Warenwirtschaftssystem des Partners */
  name: Scalars['String'];
  /** Alternative Bezeichnung des Objektes */
  name2: Maybe<Scalars['String']>;
  /**
   * Partnerspezifische Objektnummer,
   * d.h. die Nummer des Objektes/Kunden aus dem Warenwirtschaftssystem des Partners
   */
  nummer: Scalars['String'];
  /** Eigene Organisation */
  organisation: Organisation;
  /** Der Bearbeiter, der, wenn gesetzt, automatisch einer Aufgabe zugeordnet wird, wenn die Aufgabe bei der Erstellung  keinen expliziten Bearbeiter definiert. */
  standardbearbeiter: Maybe<Mitarbeiter>;
};

/** Filteroptionen für die Abfrage von Objekten mit Aufgaben */
export type ObjektFilterInput = {
  /** Filtern nach Aufgabentypen */
  aufgabentypen?: InputMaybe<Array<Scalars['String']>>;
  /** Filtern nach Objektnummern */
  objektnummern?: InputMaybe<Array<Scalars['String']>>;
  /** Suchbegriff für die Objektinformationen Name, Adresse, Channel, Betriebstyp und Nummer */
  suchbegriff?: InputMaybe<Scalars['String']>;
};

export type ObjektInput = {
  additionInformationJson?: InputMaybe<Scalars['String']>;
  adressId?: InputMaybe<Scalars['String']>;
  googleId: Scalars['String'];
  latitude: Scalars['Decimal'];
  longitude: Scalars['Decimal'];
  name: Scalars['String'];
  nummer?: InputMaybe<Scalars['String']>;
  ort: Scalars['String'];
  plz: Scalars['String'];
  strasse?: InputMaybe<Scalars['String']>;
};

export enum ObjektSortierung {
  /** Anzahl von offenen Aufgaben für das Objekt */
  Aufgabenanzahl = 'AUFGABENANZAHL',
  /** Fälligkeit der Aufgaben für das Objekt */
  Faelligkeit = 'FAELLIGKEIT',
  /** Name des Objektes */
  Name = 'NAME',
  /** Standardsortierung (Aufgabenanzahl, Objektname) */
  Standard = 'STANDARD'
}

/** Offene Aufgaben und Anzahl der Objekte, auf die sie verteilt sind */
export type OffeneAufgabenStatistik = {
  __typename: 'OffeneAufgabenStatistik';
  /** Anzahl der Objekte, die mindestens eine offene Aufgabe enthalten */
  anzahlObjekteMitOffenenAufgaben: Scalars['Int'];
  /** Anzahl der offenen Aufgaben */
  anzahlOffen: Scalars['Int'];
};

/**
 * Informationen zu einer Organisation
 * Dabei kann es sich um die eigene Organisation des Mandanten oder eine fremde Organisation handeln.
 */
export type Organisation = {
  __typename: 'Organisation';
  /** Adresse der Organisation */
  adresse: Maybe<Adresse>;
  /** Korrekte Firmierung der Organisation für die Anschrift */
  firmierung: Scalars['String'];
  /** Id der Organisation */
  id: Scalars['UUID'];
  /** Kurzbezeichnung der Organisation (Kürzel) */
  kurzbezeichnung: Scalars['String'];
  /** Name der Organisation */
  name: Maybe<Scalars['String']>;
};

/** Eintrag für die Verarbeitungshistorie */
export type Protokolleintrag = {
  __typename: 'Protokolleintrag';
  /** Name des Mitarbeiters oder 'System' */
  akteur: Scalars['String'];
  /** MitarbeiterId des Akteurs oder leer, wenn die Aktion automatisch ausgeführt wurde */
  akteurId: Maybe<Scalars['UUID']>;
  /** Kurze fachliche Beschreibung der durchgeführten Aktion */
  aktion: Scalars['String'];
  /** Erstellungzeitpunkt */
  erstellt: Scalars['DateTime'];
};

/** Queries für Artikel */
export type Query = {
  __typename: 'Query';
  /**
   * Liefert Informationen zu Artikeln.
   *
   *
   * **Returns:**
   * Liste aller Artikel
   */
  artikel: Array<Artikel>;
  /**
   * Liefert Informationen zur Aufgabe mit der übergebenen Id.
   *
   *
   * **Returns:**
   * Die Aufgabe mit der angegebenen Id oder null
   */
  aufgabe: Aufgabe;
  /**
   * Liefert die Anzahl der Aufgaben für jedes Objekt mit aktuellen Aufgaben.
   *
   *
   * **Returns:**
   * Objekte mit der Anzahl ihrer Aufgaben
   */
  aufgabenProObjekt: Array<AufgabenProObjekt>;
  /**
   * Liefert seitenweise Informationen zu allen Aufgaben.
   *
   *
   * **Returns:**
   * Angeforderte Seite mit Aufgaben
   */
  aufgabenSeitenweise: ErgebnisOfAufgabe;
  /**
   * Liefert die Anzahl der Aufgaben für jeden Status.
   *
   *
   * **Returns:**
   * Aufgabenstatistik
   */
  aufgabenStatistik: Array<AufgabenPerStatus>;
  bearbeiter: Array<Bearbeiter>;
  /** Liefert alle Betriebstypen. */
  betriebstypen: Array<Scalars['String']>;
  /** Liefert alle Channels. */
  channels: Array<Scalars['String']>;
  /**
   * Liefert Informationen zu einer Eigenschaft.
   *
   *
   * **Returns:**
   * Liste der möglichen Werte der Eigenschaft.
   */
  eigenschaft: Eigenschaft;
  /**
   * Liefert Informationen zu allen Eigenschaften.
   *
   *
   * **Returns:**
   * Liste aller Eigenschaften mit ihren möglichen Werten
   */
  eigenschaften: Array<Eigenschaft>;
  /**
   * Liefert je eine Aufgabe der aktuellen Kampagnen.
   *
   *
   * **Returns:**
   * Angeforderte Seite mit Aufgaben
   */
  kampagnenSeitenweise: ErgebnisOfKampagne;
  /**
   * Liefert Informationen zu Marken.
   *
   *
   * **Returns:**
   * Liste aller Marken
   */
  marken: Array<Marke>;
  /**
   * Liefert Informationen zu allen Objekten, denen keine Aktionsaufgabe für die Kampagne zugeordnet ist.
   * Die Objekte sind nach ihrem Namen sortiert.
   *
   *
   * **Returns:**
   * Angeforderte Seite mit Objekten ohne Aufgabe für die Kampagne
   */
  neueObjekteFuerKampagne: ErgebnisOfObjekt;
  /**
   * Liefert Informationen zum Objekt mit der übergebenen Id.
   *
   *
   * **Returns:**
   * Das Objekt mit der angegebenen Id oder null
   */
  objekt: Objekt;
  /**
   * Liefert Informationen zu allen Objekten.
   *
   *
   * **Returns:**
   * Liste aller Objekte mit Aufgaben
   */
  objekte: Array<Objekt>;
  /**
   * Liefert seitenweise Informationen zu allen Objekten mit Aufgaben.
   *
   *
   * **Returns:**
   * Angeforderte Seite mit Objekten
   */
  objekteSeitenweise: ErgebnisOfObjekt;
  /**
   * Liefert die Anzahl der offenen Aufgaben und auf wie viele Objekte diese verteilt sind
   *
   *
   * **Returns:**
   * Anzahl Offen, Anzahl Objekte mit offenen Aufgaben
   */
  offeneAufgabenStatistik: OffeneAufgabenStatistik;
  /** Liefert alle Produkte. */
  produkte: Array<Scalars['String']>;
  /**
   * Liefert Informationen zu allen Objekten auch wenn keine Aufgaben zugeordnet sind.
   *
   *
   * **Returns:**
   * Liste aller Objekte
   */
  verfuegbareObjekte: Array<Objekt>;
  /**
   * Liefert Informationen zum Objekt mit der übergebenen Id auch wenn keine Aufgaben zugerodnet sind.
   *
   *
   * **Returns:**
   * Das Objekt mit der angegebenen Id
   */
  verfuegbaresObjekt: Objekt;
  /**
   * Liefert Versionsinformationen zum Service
   *
   *
   * **Returns:**
   * Versionsinformationen
   */
  versionen: Versionsinformationen;
  /** Liefert alle Warengruppen. */
  warengruppen: Array<Scalars['String']>;
};


/** Queries für Artikel */
export type QueryArtikelArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  suchbegriff?: InputMaybe<Scalars['String']>;
};


/** Queries für Artikel */
export type QueryAufgabeArgs = {
  id: Scalars['UUID'];
};


/** Queries für Artikel */
export type QueryAufgabenSeitenweiseArgs = {
  anzahlProSeite?: Scalars['Int'];
  filter?: InputMaybe<AufgabenFilterInput>;
  seite?: Scalars['Int'];
  sortierrichtung?: Sortierrichtung;
  sortierung?: AufgabenSortierung;
};


/** Queries für Artikel */
export type QueryEigenschaftArgs = {
  eigenschaft: Scalars['String'];
  nurAktiveWerte?: Scalars['Boolean'];
};


/** Queries für Artikel */
export type QueryEigenschaftenArgs = {
  nurAktiveWerte?: Scalars['Boolean'];
};


/** Queries für Artikel */
export type QueryKampagnenSeitenweiseArgs = {
  anzahlProSeite?: Scalars['Int'];
  seite?: Scalars['Int'];
  sortierrichtung?: Sortierrichtung;
  sortierung?: KampagnenSortierung;
  suchbegriff?: InputMaybe<Scalars['String']>;
};


/** Queries für Artikel */
export type QueryMarkenArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  suchbegriff?: InputMaybe<Scalars['String']>;
};


/** Queries für Artikel */
export type QueryNeueObjekteFuerKampagneArgs = {
  anzahlProSeite?: Scalars['Int'];
  filter?: InputMaybe<ObjektFilterInput>;
  kampagne: Scalars['String'];
  seite?: Scalars['Int'];
  sortierrichtung?: Sortierrichtung;
};


/** Queries für Artikel */
export type QueryObjektArgs = {
  id: Scalars['UUID'];
};


/** Queries für Artikel */
export type QueryObjekteSeitenweiseArgs = {
  anzahlProSeite?: Scalars['Int'];
  filter?: InputMaybe<ObjektFilterInput>;
  seite?: Scalars['Int'];
  sortierrichtung?: Sortierrichtung;
  sortierung?: ObjektSortierung;
};


/** Queries für Artikel */
export type QueryVerfuegbaresObjektArgs = {
  id: Scalars['UUID'];
};

export type ResultOfString = {
  __typename: 'ResultOfString';
  error: Maybe<Scalars['String']>;
  isSuccess: Scalars['Boolean'];
  value: Maybe<Scalars['String']>;
};

/** Beschreibung der Seiten */
export type SeitenBeschreibung = {
  __typename: 'SeitenBeschreibung';
  /** Aktuelle Seite */
  aktuelleSeite: Scalars['Int'];
  /** Anzahl der Datensätze auf einer Seite */
  anzahlProSeite: Scalars['Int'];
  /** Anzahl aller Datensätze über alle Seiten */
  gesamtAnzahl: Scalars['Int'];
  /** True, wenn es eine weitere Seite gibt */
  hatNachfolger: Scalars['Boolean'];
  /** True, wenn es eine vorherige Seite gibt */
  hatVorgaenger: Scalars['Boolean'];
  /** Anzahl der Seiten mit der aktuellen Aufteilung */
  seitenAnzahl: Scalars['Int'];
};

/** Sortierreihenfolge */
export enum Sortierrichtung {
  /** Absteigende Sortierung */
  Absteigend = 'ABSTEIGEND',
  /** Aufsteigende Sortierung */
  Aufsteigend = 'AUFSTEIGEND'
}

export type VerarbeitungsErgebnis = {
  __typename: 'VerarbeitungsErgebnis';
  erfolgreich: Scalars['Boolean'];
  fehlermeldung: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** Beschreibt die Version von Assemblies */
export type Versionsinformationen = {
  __typename: 'Versionsinformationen';
  /** Die generelle Versionsnummer der API */
  apiVersion: Scalars['String'];
  clientVersion: Maybe<Scalars['String']>;
};
